import { render } from "./PackagesManagerOrdersGeneratorList1D.vue?vue&type=template&id=80c3906c&scoped=true"
import script from "./PackagesManagerOrdersGeneratorList1D.vue?vue&type=script&lang=js"
export * from "./PackagesManagerOrdersGeneratorList1D.vue?vue&type=script&lang=js"

import "./PackagesManagerOrdersGeneratorList1D.vue?vue&type=style&index=0&id=80c3906c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80c3906c"]])

export default __exports__